// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "path[data-v-012ef3f6]{transition:all .3s ease}.is-discrete path[data-v-012ef3f6]{fill:#fff!important}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.ie-logo[data-v-012ef3f6]{height:65px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
